"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartPaymentResponseDto } from "@sticker-giant/sg-frontend-common";
import { usePaymentMutation } from "./usePaymentMutation";
export const initializePayPalMutationKey = ["initializePayPal"] as const;
export function useInitializePayPalPayment() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationKey: initializePayPalMutationKey,
      method: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return usePaymentMutation(t0);
}
function _temp(cartClient, cartId) {
  return cartClient.initializePayPalPayment(cartId);
}